export const safelyRound = (num: number, maxDecimals = 0) => {
    const factor = parseInt(`1${'0'.repeat(maxDecimals)}`, 10);
    return Math.round((num + Number.EPSILON) * factor) / factor;
};

const numberUtil = {
    safelyRound,
};

export default numberUtil;
